import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const AuthRoute = ({ children }) => {
  const user = useSelector((state) => state.user);
  const urlParams = new URLSearchParams(window.location.search);
  const eventId = urlParams.get("eventId");
  const reportType = urlParams.get("reportType");
  const refId = urlParams.get("refId");
  const redirectUrlStr = React.useMemo(() => {
    if (Number(eventId) > 0 && ["EVENT", "TASK"].includes(reportType)) {
      return `/candidate-report?eventId=${eventId}&reportType=${reportType}${
        !!refId ? `&refId=${refId}` : ""
      }`;
    }
    return "/";
  }, [reportType, eventId, refId]);
  return user === null ? children : <Navigate to={redirectUrlStr} replace />;
};
export default AuthRoute;
